/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2MinusIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2MinusIcon({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2MinusIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 8,
  height = 2,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2MinusIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 8 2"
 style={{'--as-1-Z19h4rH': alignSelf,'--mt-2-Z19h4rH': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z19h4rH': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z19h4rH': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z19h4rH': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z19h4rH': opacity,'--w-10-Z19h4rH': typeof width === 'number' ? `${width}px` : width,'--h-11-Z19h4rH': typeof height === 'number' ? `${height}px` : height,'--f-12-Z19h4rH': fill,'--a-7-Z19h4rH': isAnimated ? animation : "none",'--sd-8-Z19h4rH': isAnimated ? strokeDashoffset : 0,'--sd-9-Z19h4rH': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2MinusIcon.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M1 .25a.75.75 0 000 1.5h6a.75.75 0 000-1.5H1z"
 style={{'--f-12-Z19h4rH': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}